import { useAppSelector } from '../../store/hooks';
import { Abbreviation, Language } from '../../rest/models';
import { getModelArr } from '../../rest/slice';
import { NothingToShow, PleaseWait, DictRequestStatusDisplay } from '../CommonComponents';
import { Button } from "../RequestRespectingInputs";
import { groupBy } from '../../utils';
import { GetPageTitle } from '../../ErnotsConfig';
import { AbbreviationExplanations } from './explanation';
import { AbbreviationLanguageListRow } from './AbbreviationLanguageListRow';
import { RestObjectDDL } from '../../rest/components/RestObjectDDL';
import { useEffect, useState } from 'react';

export function AbbreviationList()
{
    //Get data if it's ready.
    const abbrsModels = getModelArr(useAppSelector, Abbreviation);
    const langModels = getModelArr(useAppSelector, Language);

    const hasData = abbrsModels != null && langModels != null;

    //Languages for which AbbreviationLanguageListRows are displayed.
    const [abbrLangs, setAbbrLangs] = useState({} as {[langId: string]: true});

    //Selected value for the language dropdown.
    const [newAbbrLang, setNewAbbrLang] = useState('');

    //Adds to the dict, and then sets the state to its copy.
    //(If I don't make a copy, the page doesn't rerender.)
    function addAbbrLang(langId: string)
    {
        if (langId)
        {
            abbrLangs[langId] = true;
            setAbbrLangs({...abbrLangs});
        }
    }

    useEffect(function()
    {
        //Add languages from existing objects to abbrLangs, so their blocks aren't removed if the objects are deleted.
        Object
            .values(abbrsModels ?? {})
            .map(a => a.language)
            .filter(langId => !abbrLangs[langId])
            .forEach(addAbbrLang);
    });

    let ret = <>
        <PleaseWait what='the abbreviation table'/>
        <DictRequestStatusDisplay modelClass={Abbreviation} />
        <DictRequestStatusDisplay modelClass={Language} />
    </>;
    
    if (hasData)
    {
        langModels.sort((a, b) => a.name.localeCompare(b.name));

        //Group abbrs by language and sort by text.        
        const abbrsByLang = groupBy(abbrsModels, a => a.language, a => a.text);
        
        const langRows = langModels
            .filter(l => abbrLangs[l.key])
            .map(l => <AbbreviationLanguageListRow key={l.key} lang={l} abbrs={abbrsByLang[l.key] ?? []}/>);

        ret = langRows.length ? <>{langRows}</> : <NothingToShow what='abbreviations'/>;
    }

    return (
    <div className='ernots_ModelEditor ernots_AbbreviationEditor'>
        <title>{GetPageTitle('Abbreviations')}</title>
        {AbbreviationExplanations.header}
        
        <div className='ernots_HorizontalLine'/>
        Create abbreviations for language:
        <br/>
        <RestObjectDDL
            name='createAbbrsFor'
            modelClass={Language}
            property='name'
            hasEmptyOption={true}
            selection={newAbbrLang}
            handleChange={val => setNewAbbrLang(val)} />
        <Button onClick={e => addAbbrLang(newAbbrLang)}>Create</Button>

        {ret}
    </div>);
}